export const RouterUrlType = {
  DASHBOARD: '/secure/dashboard/landing',
  FUNDING_PIPELINE: '/secure/funding/funding-pipeline',
  FUNDING_LOAN_REQUEST: '/secure/funding/loan-request',
  FUNDING_LOAN_VIEW: '/secure/funding/loan-request/',
  SETTLEMENT: '/secure/settlement/',
  COLLATERAL: '/secure/collateral/',
  ADMIN_ORIGINATOR_PROFILE: '/secure/admin/originators/profile',
  ADMIN_GENERAL_SETUP: '/secure/admin/general-setup',
  ADMIN_BATCH_STATUS: '/secure/admin/batch-status',
  ADMIN_BATCH_TRIGGER: '/secure/admin/batch-trigger',
  /** Financing Sources setup (Financing top menu → WH tenants with feature flag). */
  FINANCING_SOURCES: '/secure/financing/financing-sources',
  TREASURY: '/secure/treasury',
  ADMIN_WIRE_RECIPIENT_SETUP: '/secure/admin/wire-recipients/setup',
  ADMIN_WIRE_RECIPIENT_PROFILE: '/secure/admin/wire-recipients',
  ADMIN_SHIPPING: '/secure/admin/shipping',
  ADMIN_WIRE_RECIPIENT_VERIFICATION:
    '/secure/admin/wire-recipient-verification',
  ADMIN_CONDITIONS: '/secure/admin/conditions',
  SUPER_ADMIN_TENANTS: '/secure/admin/tenants',
  SETTLEMENT_LANDING: '/secure/settlement/settlement-landing',
  ORIGINATORS_SUMMARY: '/secure/admin/originators',
  INDEX_SETUP: '/secure/admin/index-setup',
  INVESTOR_SUMMARY: '/secure/admin/investors',
};
